import GlobalState from 'react-global-state-management';
export const skillsheetState = GlobalState({
    project_master_data:[],
    forms:[]
});